import type { FC } from "react";

import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

import LoaderWrapper from "./LoaderWrapper";

interface LoaderProps {
  fullscreen?: boolean;
  className?: string;
}

const Loader: FC<LoaderProps> = ({ fullscreen = false, className }) => {
  const content = (
    <div
      className={cn(
        "flex items-center justify-center",
        fullscreen ? "min-h-screen" : "h-full min-h-80",
        className
      )}
    >
      <div className="border border-zinc-200 rounded-[6px] px-[37px] py-[32px] bg-[#FFF] shadow-loader">
        <Spinner color="#09090B" className="w-[46px] h-[46px]" />
      </div>
    </div>
  );

  return fullscreen ? <LoaderWrapper>{content}</LoaderWrapper> : content;
};

export default Loader;
